// Invitation page - /invitasjon/:token
// The invited person signs in with Google, and their new account is linked to the name an admin registered for them

import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { app } from './firebase-config';
import { useAuthUser } from './blaturData';

const auth = getAuth(app);
const db = getFirestore(app);

function Invitasjon() {
  const { token } = useParams();
  const user = useAuthUser();
  const [state, setState] = useState({ status: 'idle' });

  useEffect(() => {
    if (!user) return;
    const claim = async () => {
      setState({ status: 'working' });
      try {
        const inviteRef = doc(db, 'invites', token);
        const invite = await getDoc(inviteRef);
        if (!invite.exists()) return setState({ status: 'invalid' });
        const { personId, name, usedBy } = invite.data();

        const userRef = doc(db, 'users', user.uid);
        const existing = await getDoc(userRef);

        if (usedBy && usedBy !== user.uid) return setState({ status: 'used' });
        if (existing.exists() && usedBy !== user.uid) {
          return setState({ status: 'hasAccount', name: existing.data().name });
        }

        if (!usedBy) {
          await updateDoc(inviteRef, { usedBy: user.uid, usedAt: serverTimestamp() });
          await updateDoc(doc(db, 'people', personId), { uid: user.uid, claimedWith: token });
        }
        if (!existing.exists()) {
          await setDoc(userRef, { name, points: 0, attended_events: [] });
        }
        localStorage.setItem('userName', name);
        setState({ status: 'done', name });
      } catch (error) {
        console.error('Error accepting invitation: ', error);
        setState({ status: 'error', message: error.message });
      }
    };
    claim();
  }, [user, token]);

  const login = () => signInWithPopup(auth, new GoogleAuthProvider()).catch(err => console.error(err));

  return (
    <div className="admin-page invitasjon">
      <h1>🎉 Du er invitert!</h1>
      {user === null && (
        <>
          <p>Du er invitert til gjengen på Kulinarisk Laug. Logg inn med Google for å ta imot invitasjonen.</p>
          <button className="button-17" onClick={login}>Logg inn med Google</button>
        </>
      )}
      {state.status === 'working' && <p>Kobler kontoen din…</p>}
      {state.status === 'done' && (
        <>
          <p>Velkommen, <strong>{state.name}</strong>! Kontoen din er klar.</p>
          <p><Link to="/blatur">Se blåturene</Link> · <Link to="/minprofil">Min deltakelse</Link></p>
        </>
      )}
      {state.status === 'invalid' && <p>Denne invitasjonslenken finnes ikke. Be den som inviterte deg om en ny.</p>}
      {state.status === 'used' && <p>Denne invitasjonen er allerede tatt i bruk av en annen konto.</p>}
      {state.status === 'hasAccount' && (
        <p>Du har allerede en bruker her som <strong>{state.name}</strong>. Si fra til den som inviterte deg, så kobles det riktig.</p>
      )}
      {state.status === 'error' && <p>Noe gikk galt: {state.message}</p>}
    </div>
  );
}

export default Invitasjon;
